import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "@components/Table";
import { ButtonSecondary, ButtonPrimaryLink } from "@components/Button";
import Modal from "@components/Modal";
import { Span } from "@styles/typography";
import { Row, Indent } from "@styles/grid";
import { deleteBucketById } from "@actions/buckets.action";

const EditBucket = ({ bucketId }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.buckets.loading);

  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const handleDeleteBucket = () => async () => {
    try {
      await dispatch(deleteBucketById(bucketId));
      setIsRemoveModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return (
    <Row justify="flex-end" padding="0 2rem 0 0">
      <Indent margin="0 1.5rem 0 0">
        <ButtonPrimaryLink uppercase href={`/buckets/${bucketId}`} outlined size="small" weight="bold">
          edit
        </ButtonPrimaryLink>
      </Indent>
      <ButtonSecondary uppercase onClick={() => setIsRemoveModalOpen(true)} size="small" weight="bold">
        Remove
      </ButtonSecondary>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove Bucket">
        <Indent margin="4rem 0">
          <Span size={1.8}>Are you sure you want to delete this bucket?</Span>
        </Indent>
        <Row justify="flex-end">
          <Indent margin="0 2rem 0">
            <ButtonSecondary outlined onClick={() => setIsRemoveModalOpen(false)} uppercase>
              Close
            </ButtonSecondary>
          </Indent>
          <ButtonSecondary autoFocus onClick={handleDeleteBucket()} uppercase disabled={loading}>
            Remove
          </ButtonSecondary>
        </Row>
      </Modal>
    </Row>
  );
};

const BucketsTable = () => {
  const { buckets, fetching } = useSelector(({ buckets }) => buckets);
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "visibility",
        accessor: "enabled",
        Cell: ({ row }) => (
          <Span size={1.5} weight="500">
            {row.original.enabled ? "enabled" : "disabled"}
          </Span>
        ),
      },

      {
        width: 100,
        id: "colEdit",
        Cell: ({ row }) => <EditBucket bucketId={row.original.id} />,
      },
    ],
    []
  );

  const data = useMemo(() => buckets, [buckets]);

  return <Table columns={columns} data={data} hasGlobalFilter loading={fetching} />;
};

export default BucketsTable;
